export const colorByAccount = ['#8d4b54','#4a3cf7','#25ea69','#0fa1e0','#002626','#0fa1e0','#4682B4','#fe843f','#FFA500','#708090',
'#E6E6FA','#8B008B','#FFB6C1','#F5F5DC','#CD853F','#4169E1','#00FF7F','#FF0000','#ca4d22','#bad509'];
